export const locationDic = {
  "1": "Richmond, VA",
  "2": "Charlottesville, VA",
  "3": "Washington, DC",
  "4": "Virginia Beach, VA"
};